import { useBreakPoints } from 'core';
import ReactPlayer from 'react-player';
import { Stack, Text } from 'ui';

const AMessage = () => {
  const { isSmallScreen } = useBreakPoints();
  return (
    <Stack gap={'lg'}>
      <Text fw={600} fz={isSmallScreen ? 18 : 24}>
        A message from our nonprofit partner One Simple Wish
      </Text>
      <Stack style={{ position: 'relative', paddingTop: '56.25%' }}>
        <ReactPlayer
          url="https://player.vimeo.com/video/1029358481?h=1178c960dc"
          controls={true}
          width="100%"
          height="100%"
          style={{ position: 'absolute', top: 0, left: 0 }}
        />
      </Stack>
    </Stack>
  );
};
export { AMessage };
